import Map from '../../components/Map';


const Main = () => {
    return (
        <main className="mainContent h-full">
            <Map />
            {/* <SearchForm /> */}
        </main>
    )
}
export default Main;